import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

/**
 * Protected Route Component
 * - Redirects to /login if not authenticated
 * - If authenticated, always allows access (permission check disabled)
 *   Reason: Backend returns role as integer ID — client-side permission check
 *   is not possible without a separate /me or /role-detail API call.
 *   All authorization is enforced server-side via Bearer token.
 */
function ProtectedRoute({ children, permission }) {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
